module.exports = __webpack_public_path__ + "public/img/yibiaopan_lv_11.de9cdfcf.png";